// Test IDs for the Budget Trips SG landing page.
export const HOME = {
    emergentLink: "home-emergent-link",
    // Nav
    navLogo: "nav-logo",
    navPhone: "nav-phone-cta",
    // Hero
    heroPlanTrip: "hero-plan-trip-btn",
    heroExplore: "hero-explore-btn",
    // Packages
    pkgCard: "package-card",
    // Services
    serviceCard: "service-card",
    // Booking form
    formName: "booking-form-name",
    formPhone: "booking-form-phone",
    formDestination: "booking-form-destination",
    formDates: "booking-form-dates",
    formMessage: "booking-form-message",
    formSubmit: "booking-form-submit",
    formWhatsapp: "booking-form-whatsapp",
    // Footer
    footerPhone: "footer-phone-link",
    footerWhatsapp: "footer-whatsapp-link",
    footerAddress: "footer-address",
    // Floating buttons
    floatingCall: "floating-call-btn",
    floatingWhatsapp: "floating-whatsapp-btn",
};
